import { Helmet } from "react-helmet";
import styles from "./roles.module.css";
import { ArrowLeft, Home, X } from "react-feather";
import { Dialog, DialogActions, DialogContent, DialogTitle, FormControl, IconButton, InputLabel, MenuItem, Select, Slide, Snackbar, Typography } from "@mui/material";
import Footer from "../../components/Footer";
import { Button } from "react-bootstrap";
import { useAuth0, withAuthenticationRequired } from "@auth0/auth0-react";
import Loader from "../../components/Loader";
import { useState } from "react";
import RoleFilter from "./components/RoleFilter";
import RoleCard from "./components/RoleCard";
import { useEffect } from "react";
import axios from "axios";
import { TableLoaderSmall } from "../../components/LoaderC";
import AddRole from "./components/AddRole";
import { AddLogCallAPI } from "../../components/AddLogs";
import { toast } from 'react-smart-toaster';
import AssignPermission from "./components/AssignPermission";
import { useForm } from "react-hook-form";

const Roles = () => {
  const { getAccessTokenSilently } = useAuth0();
  const [loading, setLoading] = useState(false);
  const [contentLoading, setContentLoading] = useState(true);
  const [allData, setAllData] = useState([]);
  const [filterredData, setFilterredData] = useState([]);
  const [filterData, setFilterData] = useState({ searchKey: "" });
  const [addModalOpen, setAddModalOpen] = useState(false);
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [deleteModalOpen2, setDeleteModalOpen2] = useState(false);
  const [deleteModalOpen3, setDeleteModalOpen3] = useState(false);
  const [assignModalOpen, setAssignModalOpen] = useState(false);
  const [roleData, setRoleData] = useState(null);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMsg, setSnackbarMsg] = useState("");
  const [allPermissions, setAllPermissions] = useState([]);
  const [userList, setUserList] = useState([]);
  const [errorList, setErrorList] = useState([]);
  const [isUpdate, setIsUpdate] = useState(0);
  const [updateIndex, setupdateIndex] = useState(0);
  const [addRoleStep, setAddRoleStep] = useState(1);
  const [newRoleData, setNewRoleData] = useState(null);

  const { handleSubmit, formState: { isSubmitted } } = useForm({
    mode: "onChange"
  });

  useEffect(() => {
    async function getPermission() {
      const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

      axios(process.env.REACT_APP_USER_API_URL + "v1/allpermissions", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }).then((response) => {
        setAllPermissions(response.data.data);
      }).catch((error) => { });
    }
    getPermission();
  }, [getAccessTokenSilently]);

  useEffect(() => {
    async function getRoles() {
      const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

      axios(process.env.REACT_APP_USER_API_URL + "v1/roles", {
        headers: {
          Authorization: `Bearer ${token}`,
        }
      }).then((response) => {
        setContentLoading(false);
        setAllData(response.data.data);
      }).catch((error) => {
        setContentLoading(false);
      });
    }
    getRoles();
  }, [getAccessTokenSilently]);

  useEffect(() => {
    let filterredDataTemp = allData;

    if (filterData.searchKey !== "") {
      let inputVal = filterData?.searchKey;
      inputVal = inputVal.toLowerCase();
      filterredDataTemp = filterredDataTemp.filter((item) => {
        return (item?.name.toLowerCase().includes(inputVal) || item?.description.toLowerCase().includes(inputVal));
      });
    }

    setFilterredData(filterredDataTemp);
  }, [allData, filterData]);

  const confirmDelete = async () => {
    setDeleteModalOpen(false);
    setDeleteModalOpen3(false);
    setLoading(true);
    const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

    axios.delete(process.env.REACT_APP_USER_API_URL + 'v1/roles/' + roleData?.id, {
      headers: {
        Authorization: `Bearer ${token}`,
      }
    }).then(response => {
      setLoading(false);
      setSnackbarOpen(true);
      setSnackbarMsg(response.data.message);

      setAllData(prev => {
        return prev?.filter(i => i?.id !== roleData?.id);
      });

      let logData = {
        'title': 'A role has been deleted',
        'description': [
          'Name: ' + roleData?.name
        ]
      }
      AddLogCallAPI(logData, token);
      setRoleData(null);
    }).catch(error => {
      if (typeof error.response !== 'undefined')
        toast.error(error.response.data.message);
      setLoading(false);
    });
  }

  const setCheckAssignedUser = async (item) => {
    if (item) {
      const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });
      setLoading(true);
      axios(process.env.REACT_APP_USER_API_URL + 'v1/user-list/' + item?.id, {
        headers: {
          Authorization: `Bearer ${token}`,
        }
      }).then(response => {
        setLoading(false);
        setDeleteModalOpen2(true);

        let userTemp = response.data.data?.map(i => {
          return { id: i?.id, user_id: i?.user_id, name: i?.name, prev_role: item?.id, role: '', role_id: '' };
        });
        setUserList(userTemp);
      }).catch(error => {
        setUserList([]);
        setLoading(false);
      });
    }
  }

  useEffect(() => {
    if (isSubmitted) {
      const errorTempList = userList?.map(item => {
        let errNew = false;
        if (item?.role_id === '') {
          errNew = true;
        }
        return errNew;
      });
      setErrorList(errorTempList);
    }
  }, [userList, isSubmitted]);

  const updateUserRole = () => {
    let error1 = false;
    userList?.map(item => {
      if (item?.role === '') {
        error1 = true;
      }
      return null;
    });
    if (error1) {
      return false;
    }
    setLoading(true);
    axios.post(process.env.REACT_APP_USER_API_URL + 'v1/update-user-roles', { users: userList }).then(response => {
      setLoading(false);
      setDeleteModalOpen2(false);
      setDeleteModalOpen3(true);
    }).catch(error => {
      setLoading(false);
    });
  }

  const assignPremission = async (newPermissionList) => {
    setAssignModalOpen(false);
    setLoading(true);
    const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

    axios.post(process.env.REACT_APP_USER_API_URL + 'v1/roles/' + roleData?.id + '/permissions', { permissions: newPermissionList }, {
      headers: {
        Authorization: `Bearer ${token}`,
      }
    }).then(response => {
      setLoading(false);
      setSnackbarOpen(true);
      setSnackbarMsg(response.data.message);

      setIsUpdate(prev => {
        return prev + 1;
      });

      setupdateIndex(roleData?.id);

      let logData = {
        'title': 'Role permissions have been updated',
        'description': [
          'Name: ' + roleData?.name
        ]
      }
      AddLogCallAPI(logData, token);
    }).catch(error => {
      if (typeof error.response !== 'undefined')
        toast.error(error.response.data.message);
      setLoading(false);
    });
  }

  const addNewRole = async (newPermissionList) => {
    setLoading(true);
    setAddModalOpen(false);

    const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

    let data = newRoleData;
    data = { ...data, permissions: newPermissionList };

    return axios.post(process.env.REACT_APP_USER_API_URL + 'v1/roles', data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }).then(response => {
      setLoading(false);

      setSnackbarOpen(true);
      setSnackbarMsg(response.data.message);

      setIsUpdate(prev => {
        return prev + 1;
      });

      setupdateIndex(response.data.data?.id);


      setAllData(prev => {
        return [response.data.data].concat(prev);
      });

      let logData = {
        'title': 'A new role has been added.',
        'description': [
          'Name: ' + response.data.data?.name
        ]
      }
      AddLogCallAPI(logData, token);
    }).catch(error => {
      if (typeof error.response !== 'undefined')
        toast.error(error.response.data.message);
      setLoading(false);
    });
  }

  const editRole = async (newPermissionList) => {
    setLoading(true);
    setAddModalOpen(false);

    const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

    let data = newRoleData;
    data = { ...data, permissions: newPermissionList };

    return axios.post(process.env.REACT_APP_USER_API_URL + 'v1/roles/' + roleData?.id, data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }).then(response => {
      setLoading(false);

      setSnackbarOpen(true);
      setSnackbarMsg(response.data.message);

      setIsUpdate(prev => {
        return prev + 1;
      });

      setupdateIndex(response.data.data?.id);

      setAllData(prev => {
        return prev?.map(i => {
          if (i?.id === roleData?.id)
            return { ...i, name: response.data.data?.name, description: response.data.data?.description };
          return i;
        });
      });

      let logData = {
        'title': 'A role has been updated.',
        'description': [
          'Name: ' + response.data.data?.name
        ]
      }
      AddLogCallAPI(logData, token);
    }).catch(error => {
      if (typeof error.response !== 'undefined')
        toast.error(error.response.data.message);
      setLoading(false);
    });
  }

  return (<>
    {loading && <Loader />}
    <Helmet title="Roles" />

    <div className={`${styles.pageTitleWrap}`}>
      <Typography display="inline" className={`${styles.pageTitle}`}>Roles</Typography>
      <nav aria-label="breadcrumb">
        <ol className={`${styles.breadcrumb}`}>
          <li className={`${styles.breadcrumbItem}`}><span><Home /></span>Roles</li>
          <li className={`${styles.breadcrumbItem} ${styles.active}`}>List</li>
        </ol>
      </nav>
    </div>

    <div className={`${styles.BodyCon}`}>
      <div className={`${styles.mainCardDiv}`}>
        <div className={`${styles.mainCard}`}>

          {contentLoading && <div className="Loader TableLoader"><TableLoaderSmall /></div>}

          {!contentLoading && <div className="control-pane">
            <div className={`${styles.Row}`}>

              <RoleFilter setFilterData={setFilterData.bind(this)} setAddModalOpen={setAddModalOpen.bind(this)} setAddRoleStep={setAddRoleStep.bind(this)} />

              <div className={`${styles.NotesRow}`}>

                {filterredData?.map((item, index) => {
                  return <RoleCard item={item} itemIndex={index} setEditData={setRoleData.bind(this)} setEditModalOpen={setEditModalOpen.bind(this)} setDeleteModalOpen={setDeleteModalOpen.bind(this)} setCheckAssignedUser={setCheckAssignedUser.bind(this)} setAssignModalOpen={setAssignModalOpen.bind(this)} isUpdate={isUpdate} updateIndex={updateIndex} setAddRoleStep={setAddRoleStep.bind(this)} />
                })}

              </div>
            </div>

          </div>}
        </div>
      </div>

      <Dialog
        open={addModalOpen}
        onClose={(e) => setAddModalOpen(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className="NewPopUp MobileForm"
        fullWidth
        maxWidth={addRoleStep === 2 ? "md" : "sm"}
      >
        <DialogTitle id="alert-dialog-title">
          <button className={`${styles.BackAddBU}`} onClick={(e) => setAddModalOpen(false)}><ArrowLeft /></button>
          {addRoleStep === 2 ? "Assign Permissions to " + newRoleData?.name : "Add New Role"}
          <button onClick={(e) => setAddModalOpen(false)}><X /></button>
        </DialogTitle>
        <DialogContent className={`${styles.RequestBodyPop}`}>
          {addRoleStep === 1 && <AddRole setAddModalOpen={setAddModalOpen.bind(this)} roleData={null} setAddRoleStep={setAddRoleStep.bind(this)} setNewRoleData={setNewRoleData.bind(this)} />}
          {addRoleStep === 2 && <AssignPermission setAssignModalOpen={setAssignModalOpen.bind(this)} allPermissions={allPermissions} roleData={null} assignPremission={addNewRole.bind(this)} />}
        </DialogContent>
      </Dialog>

      <Dialog
        open={editModalOpen}
        onClose={(e) => setEditModalOpen(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className="NewPopUp MobileForm"
        fullWidth
        maxWidth={addRoleStep === 2 ? "md" : "sm"}
      >
        <DialogTitle id="alert-dialog-title">
          <button className={`${styles.BackAddBU}`} onClick={(e) => setEditModalOpen(false)}><ArrowLeft /></button>
          {addRoleStep === 2 ? "Assign Permissions to " + newRoleData?.name : "Edit Role: " + roleData?.name}
          <button onClick={(e) => setEditModalOpen(false)}><X /></button>
        </DialogTitle>
        <DialogContent className={`${styles.RequestBodyPop}`}>
          {addRoleStep === 1 && <AddRole setAddModalOpen={setEditModalOpen.bind(this)} roleData={roleData} setNewRoleData={setNewRoleData.bind(this)} setAddRoleStep={setAddRoleStep.bind(this)} />}
          {addRoleStep === 2 && <AssignPermission setAssignModalOpen={setAssignModalOpen.bind(this)} allPermissions={allPermissions} roleData={roleData} assignPremission={editRole.bind(this)} />}


        </DialogContent>
      </Dialog>

      <Dialog
        open={assignModalOpen}
        onClose={(e) => setAssignModalOpen(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className="NewPopUp MobileForm"
        fullWidth
        maxWidth="md"
      >
        <DialogTitle id="alert-dialog-title">
          <button className={`${styles.BackAddBU}`} onClick={(e) => setAssignModalOpen(false)}><ArrowLeft /></button>
          Assign Permissions to {roleData?.name}
          <button onClick={(e) => setAssignModalOpen(false)}><X /></button>
        </DialogTitle>
        <DialogContent className={`${styles.RequestBodyPop}`}>
          <AssignPermission setAssignModalOpen={setAssignModalOpen.bind(this)} allPermissions={allPermissions} roleData={roleData} assignPremission={assignPremission.bind(this)} />
        </DialogContent>
      </Dialog>

      <Dialog
        open={deleteModalOpen}
        onClose={(e) => setDeleteModalOpen(false)}
        fullWidth
        maxWidth="sm"
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className="NewPopUp"
      >
        <DialogTitle id="alert-dialog-title">Are you sure you want to delete this role?<button onClick={(e) => setDeleteModalOpen(false)}><X /></button></DialogTitle>
        <DialogContent>
          <div className="ModalFormGroup">
            <label className="PopupBodyText">If you delete it, you won't be able to restore it later. Would you like to continue?</label>
          </div>
        </DialogContent>
        <DialogActions>
          <Button onClick={(e) => confirmDelete()} className="CancelPopupBU">Delete</Button>
          <Button onClick={(e) => setDeleteModalOpen(false)} className="SubmitPopupBU">Cancel</Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={deleteModalOpen3}
        onClose={(e) => setDeleteModalOpen3(false)}
        fullWidth
        maxWidth="sm"
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className="NewPopUp"
      >
        <DialogTitle id="alert-dialog-title">Are you sure you want to delete this role?<button onClick={(e) => setDeleteModalOpen3(false)}><X /></button></DialogTitle>
        <DialogContent>
          <div className="ModalFormGroup">
            <label className="PopupBodyText">This role is now unassigned. If you delete it, you won't be able to restore it later. Would you like to continue?</label>
          </div>
        </DialogContent>
        <DialogActions>
          <Button onClick={(e) => confirmDelete()} className="CancelPopupBU">Delete</Button>
          <Button onClick={(e) => setDeleteModalOpen3(false)} className="SubmitPopupBU">Cancel</Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={deleteModalOpen2}
        onClose={(e) => setDeleteModalOpen2(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className="NewPopUp"
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle id="alert-dialog-title">
          Would you like to manage assigned users now?
          <button onClick={(e) => setDeleteModalOpen2(false)}><X /></button>
        </DialogTitle>
        <DialogContent className={`${styles.RequestBodyPop}`}>
          <form onSubmit={handleSubmit(updateUserRole)}>
            <div className={`${styles.ReqAddRow}`}>
              <div className="ModalFormGroup">
                <label className="PopupBodyText">
                  This role cannot be deleted because it is currently assigned to users. Please reassign them to another role before deleting.
                </label>
                <p className={`${styles.DeleteRoleSubText}`}>Total users with this role: 5</p>
              </div>
              <ol className={`${styles.SelectedDeviceList}`}>
                {userList?.map((i, index) => {
                  return <li>
                    <p>{i?.name} -</p>
                    <div className={`${styles.SelectRoomStepTwo} FormGroup SelectRoom Two Role`}>
                      <FormControl fullWidth>
                        <InputLabel id="demo-simple-select-label">Select Role</InputLabel>
                        <Select
                          labelId="demo-simple-select-label"
                          id="demo-simple-select"
                          label="Select Role"
                          onChange={(e) => {
                            let selRole = e.target.value;
                            let selRoleL = '';
                            let selRole2 = allData?.filter(m => m?.id === selRole);
                            if (selRole2.length > 0) {
                              selRoleL = selRole2[0]?.name;
                            }

                            setUserList(prev => {
                              return prev?.map((j) => {
                                if (j?.id === i?.id) {
                                  return { ...j, role_id: selRole, role: selRoleL };
                                }
                                return j;
                              });
                            });
                          }}
                        >
                          {allData?.map((k) => {
                            return <MenuItem value={k?.id} disabled={k?.id === roleData?.id}>{k?.name}</MenuItem>
                          })}
                        </Select>
                      </FormControl>

                    </div>
                    {errorList.length > 0 && errorList[index] && (<p className={`${styles.ErrorM}`}>Please select role</p>)}
                  </li>
                })}
              </ol>
            </div>
            <div className={`${styles.ButtonActionTwo}`}>
              <Button onClick={(e) => setDeleteModalOpen2(false)} className="CancelPopupBU">Cancel</Button>
              <Button type="submit" className="SubmitPopupBU" >Move</Button>
            </div>
          </form>
        </DialogContent>
      </Dialog>

      <Snackbar
        open={snackbarOpen}
        onClose={(e) => setSnackbarOpen(false)}
        TransitionComponent={Slide}
        message={snackbarMsg}
        autoHideDuration={10000}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        action={
          <IconButton
            size="small"
            aria-label="close"
            color="inherit"
            onClick={(e) => setSnackbarOpen(false)}
          >
            <X />
          </IconButton>
        }
      />

      <Footer />
    </div >
  </>)
}

export default withAuthenticationRequired(Roles, {
  onRedirecting: () => <Loader />,
});
